export default __webpack_public_path__ + "static/media/PLU-BEERCARD-A4-2-bckg-1.cf854499.jpg";